module.exports = __webpack_public_path__ + "img/tuijianzhishu.02b1c7ed.png";